define(['app', 'jquery', 'selectize'], function (app, $) {
  return app.Marionette.ItemView.extend({
    template: false,

    ui: {
      taginput: '.js-input-tags',
      hiddenContainer: '.js-hidden-container'
    },

    updateTags: function (value) {
      var hiddenContainer = this.$el.find(this.ui.hiddenContainer)
      var tagArray = value.split(',')
      var formName = this.$el.data('data').formName
      var timestamp = new Date().getTime()

      $(hiddenContainer).html('')

      app._.each(tagArray, function (val) {
        $(hiddenContainer).append(
          $('<input>').attr({
            type: 'hidden',
            value: val,
            name: formName,
            id: 'hidden_' + timestamp
          })
        )
      })
    },

    initialize: function () {
      var self = this

      $(self.ui.taginput).selectize({
        plugins: {
          remove_button: {
            title: ''
          }
        },
        onDropdownOpen: function () {
          this.close()
        },
        delimiter: ',',
        persist: false,
        render: {
          item: function (data, escape) {
            return '<div class="item">' + escape(data['text']) + '</div>'
          },
          option_create: function (data, escape) {
            return '<div class="create">' + escape(data.input) + '</div>'
          }
        },
        create: function (input) {
          return {
            value: input,
            text: input
          }
        },
        onChange: function (value) {
          self.updateTags(value)
        },
        onInitialize: function () {
          var self = this

          this.$control_input.on('keydown', function (e) {
            var inputValue = self.$control_input.val().trim()

            if (e.keyCode === 13 && inputValue !== '') {
              self.addOption({ value: inputValue, text: inputValue })
              self.addItem(inputValue)
              e.preventDefault()
              self.$control_input.val('')
            }
          })

          // clear unfinished tags on click (outside) to deactivate control
          $(document).on('click', function () {
            self.$control_input.val('')
          })
        }
      })
    }
  })
})
